// import React,{useEffect} from "react";
// import { BrowserRouter } from "react-router-dom";
// import AppRouter from "../src/components/AppRouter"; // Adjust the path if needed
// import { BusinessProvider } from "./components/BusinessContext";
// import { AuthProvider} from './globals/AuthContext';
// function App() {

//   return (
//     <AuthProvider>
//    <BusinessProvider>
//      <BrowserRouter>
//       <AppRouter />
//     </BrowserRouter>
//    </BusinessProvider>
//   </AuthProvider>
//   );
// }

// export default App;

// App.js
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "../src/components/AppRouter";
import { BusinessProvider } from "./components/BusinessContext";
import { AuthProvider, useAuth } from "./globals/AuthContext";
import "./languagetranslate/i18n";
import i18n from "./languagetranslate/i18n";
import { useEffect, useMemo, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createPointGenieTheme } from "./theme/pointgenieTheme";

function getSystemThemeMode() {
  if (typeof window === "undefined") return "light";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

const AppContent = () => {
  const { authReady } = useAuth();
  const [themeMode, setThemeMode] = useState(getSystemThemeMode);
  const theme = useMemo(() => createPointGenieTheme(themeMode), [themeMode]);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 3000);

    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Location lookup failed with ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.country_code === "ES") {
          i18n.changeLanguage("es");
        } else {
          i18n.changeLanguage("en");
        }
      })
      .catch(() => {
        i18n.changeLanguage("en");
      })
      .finally(() => {
        window.clearTimeout(timeoutId);
      });

    return () => {
      window.clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = themeMode;
    document.documentElement.style.colorScheme = themeMode;
  }, [themeMode]);

  useEffect(() => {
    const media = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!media) return undefined;

    const onSystemThemeChange = (event) => {
      setThemeMode(event.matches ? "dark" : "light");
    };

    media.addEventListener?.("change", onSystemThemeChange);
    return () => media.removeEventListener?.("change", onSystemThemeChange);
  }, []);

  if (!authReady) {
    return null; // or show a splash screen
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BusinessProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </BusinessProvider>
    </ThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
